export const couponsRedirect = () => {
    function setSessionStorageWithExpiry(key, value, ttlInMinutes) {
        const now = new Date();
        const item = {
            value: value,
            expiry: now.getTime() + ttlInMinutes * 60 * 1000
        };
        sessionStorage.setItem(key, JSON.stringify(item));
    }
    function getSessionStorageWithExpiry(key) {
        const itemStr = sessionStorage.getItem(key);

        if (!itemStr) {
            return null;
        }

        const item = JSON.parse(itemStr);
        const now = new Date().getTime();

        if (now > item.expiry) {
            sessionStorage.removeItem(key);
            return null;
        }

        return item.value;
    }

    const interval = setInterval(() => {
        const signUpBtn = document.querySelector('[data-component-uid="bltab3120549fd1e512"] .cds-promo-form__submit-button');
        signUpBtn?.addEventListener('click', () => {
            const thankYouInterval = setInterval(() => {
                const thankYouLink = document.querySelector('.thank-you a');
                thankYouLink?.addEventListener('click', () => {
                    setSessionStorageWithExpiry("couponPageAccess", "true", 10);
                    clearInterval(interval);
                    clearInterval(thankYouInterval);
                });
            }, 1000);
        });
    }, 1000);

    const hasAccess = getSessionStorageWithExpiry("couponPageAccess") === 'true';

    const isCouponPage =
        window.location.pathname.replace(/\/$/, '') ===
        '/coupons/coupons-page';

    if (isCouponPage && !hasAccess) {
        window.location.href = '/coupons';
    }
}